import { app } from '../../../../app';
import { Controller } from './remove-application.controller';

app.component('companyManageApplicationRemove', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./remove-application.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remove/remove-application.component.js